export interface Shipment {
  readonly id: string;
  readonly orderId: string;
  readonly carrier: string;
  readonly trackingNumber: string | null;
  readonly status: ShipmentStatus;
  readonly shippedAt: string | null;
  readonly deliveredAt: string | null;
  readonly recipient: string;
}

export const ShipmentStatus = {
  Pending: 'pending',
  InTransit: 'in_transit',
  Delivered: 'delivered',
  Returned: 'returned',
} as const;
export type ShipmentStatus = (typeof ShipmentStatus)[keyof typeof ShipmentStatus];

export const ALL_SHIPMENT_STATUSES: readonly ShipmentStatus[] = [
  ShipmentStatus.Pending,
  ShipmentStatus.InTransit,
  ShipmentStatus.Delivered,
  ShipmentStatus.Returned,
];

export const SHIPMENT_STATUS_LABELS: Readonly<Record<ShipmentStatus, string>> = {
  [ShipmentStatus.Pending]: 'Pending',
  [ShipmentStatus.InTransit]: 'In transit',
  [ShipmentStatus.Delivered]: 'Delivered',
  [ShipmentStatus.Returned]: 'Returned',
};
